const ConvModes = [
    "Convert With Same Ratio(recommended)",
    "Convert With Same Distance",
    "Convert With Same Angle"
]


const Games = [
    "CS:GO",
    "Overwatch",
    "Battlefield 1",
    "Battlefield V",
    "Apex Legends"
]

const ScreenRatio = [
    {
        text: "21:9",
        value: { w: 21, h: 9 }
    },
    {
        text: "16:9",
        value: { w: 16, h: 9 }
    },
    {
        text: "16:10",
        value: { w: 16, h: 10 }
    },
    {
        text: "4:3",
        value: { w: 4, h: 3 }
    },
]

const GameRatio = [
    { text: "21:9 Stretched", value: { w: 21, h: 9, stretch: true } },
    { text: "21:9 Black Bar", value: { w: 21, h: 9, stretch: false } },
    { text: "16:9 Stretched", value: { w: 16, h: 9, stretch: true } },
    { text: "16:9 Black Bar", value: { w: 16, h: 9, stretch: false } },
    { text: "16:10 Stretched", value: { w: 16, h: 10, stretch: true } },
    { text: "16:10 Black Bar", value: { w: 16, h: 10, stretch: false } },
    { text: "4:3 Stretched", value: { w: 4, h: 3, stretch: true } },
    { text: "4:3 Black Bar", value: { w: 4, h: 3, stretch: false } },
]

function clearLayout(layout, data) {
    layout.dt1Label =
        layout.dt2Label =
        layout.dt3Label =
        layout.op1Label =
        layout.op2Label = "No Need To Input";
    layout.op1Item = [];
    layout.op2Item = [];
    layout.fovDisable =
        layout.dt1Disable =
        layout.dt2Disable =
        layout.dt3Disable =
        layout.op1Disable =
        layout.op2Disable = true;
    layout.dt1RO = layout.dt2RO = layout.dt3RO = false;
    data.val1 = data.val2 = data.val3 = "";
    data.op1 = data.op2 = "";
}

function toRad(x) {
    return x * (Math.PI / 180);
}

// function toDeg(x) {
//     return (x * 180) / Math.PI;
// }

function filterData(x) {
    if (!x) return NaN;
    return parseFloat(x);
}

function filterResult(x) {
    return x ? x : "Invalid Input";
}

function vFOV2hFOV(vfov, w, h) {
    return 2 * Math.atan(w / h * Math.tan(vfov / 2))
}

function GetRatio(sameDist, dist, data) {
    if (!sameDist) return dist / 100;
    let sw = data.screenRT.w;
    let sh = data.screenRT.h;
    let size = filterData(data.screenSZ) * 2.54;
    let gw = data.gameRT.w;
    let gh = data.gameRT.h;

    let width = size * Math.cos(Math.atan(sh / sw));
    let height = size * Math.sin(Math.atan(sh / sw));
    if (sw * gh <= sh * gw) return dist * 2 / width;
    if (data.gameRT.stretch) return dist * (gw / sw) / (height * (gw / gh) / 2);
    return dist / (height * (gw / gh) / 2)
}

const GameInfo = {
    "CS:GO": {
        modes: ["Hipfire", "SG553,AUG", "AWP,SSG08,G3SG1,SCAR20 1x", "AWP 2x", "SSG08,G3SG1,SCAR20 2x"],

        mode2vfov: {
            "Hipfire": toRad(73.739795),
            "SG553,AUG": toRad(34.515877),
            "AWP,SSG08,G3SG1,SCAR20 1x": toRad(30.536943),
            "AWP 2x": toRad(7.508333),
            "SSG08,G3SG1,SCAR20 2x": toRad(11.278142)
        },

        mode2k: {
            "SG553,AUG": 0.5,
            "AWP,SSG08,G3SG1,SCAR20 1x": 4 / 9,
            "AWP 2x": 1 / 9,
            "SSG08,G3SG1,SCAR20 2x": 1 / 6
        },
        baseSpeed: 1 / 16363.6364,

        onModeSet: function (layout, data, is1) {
            clearLayout(layout, data);
            data.fov = 90;
            layout.dt1Disable = false;
            if (data.mode != "Hipfire") {
                layout.dt1Label = "Sensitivity";
                layout.dt2Label = is1 ? "ADS Sensitivity" : "ADS Sensitivity(Outcome)";
                layout.dt2Disable = false;
                layout.dt2RO = is1 ? false : true;
            } else {
                layout.dt1Label = is1 ? "Sensitivity" : "Sensitivity(Outcome)";
                layout.dt1RO = is1 ? false : true;
            }
        },

        getTanFOV: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            return Math.tan(vFOV2hFOV(this.mode2vfov[mode], w, h) / 2)
        },

        getSpeed: function (data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") return this.baseSpeed * filterData(data.dpi) * filterData(data.val1);
            return this.baseSpeed * filterData(data.dpi) * filterData(data.val1) * this.mode2k[data.mode] * filterData(data.val2);
        },

        calcSens: function (speed, data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") {
                data.val1 = filterResult(filterData(speed) / (this.baseSpeed * filterData(data.dpi)));
                return;
            }
            data.val2 = filterResult(
                filterData(speed) / (this.baseSpeed * filterData(data.dpi) * filterData(data.val1) * this.mode2k[data.mode])
            );
        }
    },

    "Overwatch": {
        modes: ["Hipfire", "Ashe ADS", "Widowmaker,Ana ADS"],

        mode2vfov: {
            "Ashe ADS": toRad(40),
            "Widowmaker,Ana ADS": toRad(30),
        },

        baseSpeed: 1 / 54545.4545,

        onModeSet: function (layout, data, is1) {
            clearLayout(layout, data);
            data.fov = 103;
            layout.fovDisable = false;
            layout.dt1Disable = false;
            if (data.mode != "Hipfire") {
                layout.dt1Label = "Sensitivity";
                layout.dt2Label = is1 ? "ADS Sensitivity%" : "ADS Sensitivity%(Outcome)";
                layout.dt2Disable = false;
                layout.dt2RO = is1 ? false : true;
            } else {
                layout.dt1Label = is1 ? "Sensitivity" : "Sensitivity(Outcome)";
                layout.dt1RO = is1 ? false : true;
            }
        },

        getTanFOV: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            let theta = mode == "Hipfire" ? toRad(filterData(data.fov)) : vFOV2hFOV(this.mode2vfov[mode], w, h);
            return Math.tan(theta / 2);
        },

        getSpeed: function (data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") return this.baseSpeed * filterData(data.dpi) * filterData(data.val1);
            return this.baseSpeed * filterData(data.dpi) * filterData(data.val1) * filterData(data.val2) / 100;
        },

        calcSens: function (speed, data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") {
                data.val1 = filterResult(filterData(speed) / (this.baseSpeed * filterData(data.dpi)));
                return;
            }
            data.val2 = filterResult(
                filterData(speed) / (this.baseSpeed * filterData(data.dpi) * filterData(data.val1)) * 100
            );
        }
    },

    "Battlefield 1": {
        modes: ["Hipfire", "1x", "1.25x", "1.5x",
            "2x", "2.5x", "3x"
            , "3.5x", "4x", "5x"
            , "6x", "8x", "10x"],

        mode2vfov: {
            "1x": toRad(55), "1.25x": toRad(45.2), "1.5x": toRad(38.3),
            "2x": toRad(29.2), "2.5x": toRad(23.5), "3x": toRad(19.7)
            , "3.5x": toRad(16.9), "4x": toRad(14.8), "5x": toRad(11.9)
            , "6x": toRad(9.9), "8x": toRad(7.45), "10x": toRad(5.95)
        },

        mode2adsvfov: {
            "1x": (x) => { return toRad(x); },
            "1.25x": (x) => { return toRad(-5.3 + 0.9157 * x); },
            "1.5x": (x) => { return toRad(-7.5396 + 0.8297 * x); },
            "2x": (x) => { return toRad(-8.5542 + 0.682 * x); },
            "2.5x": (x) => { return toRad(-8.1081 + 0.5703 * x); },
            "3x": (x) => { return toRad(-7.3896 + 0.4885 * x); },
            "3.5x": (x) => { return toRad(-6.6674 + 0.4248 * x); },
            "4x": (x) => { return toRad(-6.0295 + 0.3754 * x); },
            "5x": (x) => { return toRad(-5.0297 + 0.305 * x); },
            "6x": (x) => { return toRad(-4.2708 + 0.2552 * x); },
            "8x": (x) => { return toRad(-3.2781 + 0.1932 * x); },
            "10x": (x) => { return toRad(-2.6425 + 0.1547 * x); }
        },

        baseSpeed: (x) => { return 0.006366196221249355 * x + 0.00003183142049030221; },
        invBaseSpeed: (x) => { return (x - 0.00003183142049030221) / 0.006366196221249355; },

        onModeSet: function (layout, data, is1) {
            clearLayout(layout, data);
            data.fov = 55;
            layout.fovDisable = false;
            layout.dt1Disable = false;
            if (data.mode != "Hipfire") {
                layout.dt1Label = "Sensitivity";
                layout.dt2Label = "ADS Sensitivity%";
                layout.dt2Disable = false;
                data.val2 = 100;
                layout.dt3Label = is1 ? data.mode + "ADS Sensitivity%" : data.mode + "ADS Sensitivity%(Outcome)";
                layout.dt3Disable = false;
                layout.dt3RO = is1 ? false : true;

                layout.op1Label = "ADS FOV";
                layout.op1Disable = false;
                layout.op1Item = ["On", "Off"];
                data.op1 = "Off";
            } else {
                layout.dt1Label = is1 ? "Sensitivity" : "Sensitivity(Outcome)";
                layout.dt1RO = is1 ? false : true;
            }
        },

        getTanFOV: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            let fov = filterData(data.fov)
            let theta = mode == "Hipfire" ? vFOV2hFOV(toRad(fov), w, h) :
                (data.op1 == "Off" ? vFOV2hFOV(this.mode2vfov[mode], w, h) : vFOV2hFOV(this.mode2adsvfov[mode](fov), w, h));
            return Math.tan(theta / 2);
        },

        getSpeed: function (data) {
            let mode = data.mode;
            if (!mode) return NaN;
            let dpi = filterData(data.dpi);
            if (mode == "Hipfire") return this.baseSpeed(filterData(data.val1)) * dpi;

            let fov = filterData(data.fov);
            let k = (data.op1 == "Off" ? this.mode2vfov[mode] : this.mode2adsvfov[mode](fov)) / toRad(fov);
            return this.baseSpeed(filterData(data.val1)) * dpi * k * filterData(data.val2) / 100.0 * filterData(data.val3) / 100.0;
        },

        calcSens: function (speed, data) {
            let mode = data.mode;
            if (!mode) return NaN;
            let dpi = filterData(data.dpi);
            if (mode == "Hipfire") {
                data.val1 = filterResult(this.invBaseSpeed(filterData(speed) / dpi));
                return;
            }
            let fov = filterData(data.fov);
            let k = (data.op1 == "Off" ? this.mode2vfov[mode] : this.mode2adsvfov[mode](fov)) / toRad(fov);
            console.log(fov, this.mode2vfov[mode], k, data.op1);
            data.val3 = filterResult(
                filterData(speed) / (this.baseSpeed(filterData(data.val1)) * data.dpi * k * filterData(data.val2) / 100.0) * 100
            );
        }
    },

    "Battlefield V": {
        modes: ["Hipfire", "1x", "1.25x", "1.5x",
            "2x", "2.5x", "3x"
            , "3.5x", "4x", "5x"
            , "6x", "8x", "10x"],

        mode2vfov: {
            "1x": toRad(55), "1.25x": toRad(45.2), "1.5x": toRad(38.3),
            "2x": toRad(29.2), "2.5x": toRad(23.5), "3x": toRad(19.7)
            , "3.5x": toRad(16.9), "4x": toRad(14.8), "5x": toRad(11.9)
            , "6x": toRad(9.9), "8x": toRad(7.45), "10x": toRad(5.95)
        },

        mode2adsvfov: {
            "1x": (x) => { return toRad(x); },
            "1.25x": (x) => { return toRad(-5.3 + 0.9157 * x); },
            "1.5x": (x) => { return toRad(-7.5396 + 0.8297 * x); },
            "2x": (x) => { return toRad(-8.5542 + 0.682 * x); },
            "2.5x": (x) => { return toRad(-8.1081 + 0.5703 * x); },
            "3x": (x) => { return toRad(-7.3896 + 0.4885 * x); },
            "3.5x": (x) => { return toRad(-6.6674 + 0.4248 * x); },
            "4x": (x) => { return toRad(-6.0295 + 0.3754 * x); },
            "5x": (x) => { return toRad(-5.0297 + 0.305 * x); },
            "6x": (x) => { return toRad(-4.2708 + 0.2552 * x); },
            "8x": (x) => { return toRad(-3.2781 + 0.1932 * x); },
            "10x": (x) => { return toRad(-2.6425 + 0.1547 * x); }
        },

        baseSpeed: (x) => { return 0.006366196221249355 * x + 0.00003183142049030221; },
        invBaseSpeed: (x) => { return (x - 0.00003183142049030221) / 0.006366196221249355; },

        onModeSet: function (layout, data, is1) {
            clearLayout(layout, data);
            data.fov = 55;
            layout.fovDisable = false;
            layout.dt1Disable = false;
            if (data.mode != "Hipfire") {
                layout.dt1Label = "Sensitivity";
                layout.dt2Label = "ADS Sensitivity%";
                layout.dt2Disable = false;
                data.val2 = 100;
                layout.dt3Label = is1 ? data.mode + "ADS Sensitivity%" : data.mode + "ADS Sensitivity%(Outcome)";
                layout.dt3Disable = false;
                layout.dt3RO = is1 ? false : true;

                layout.op1Label = "ADS FOV";
                layout.op1Disable = false;
                layout.op1Item = ["On", "Off"];
                data.op1 = "Off";
            } else {
                layout.dt1Label = is1 ? "Sensitivity" : "Sensitivity(Outcome)";
                layout.dt1RO = is1 ? false : true;
            }
        },

        getTanFOV: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            let fov = filterData(data.fov)
            let theta = mode == "Hipfire" ? vFOV2hFOV(toRad(fov), w, h) :
                (data.op1 == "Off" ? vFOV2hFOV(this.mode2vfov[mode], w, h) : vFOV2hFOV(this.mode2adsvfov[mode](fov), w, h));
            return Math.tan(theta / 2);
        },

        getSpeed: function (data) {
            let mode = data.mode;
            if (!mode) return NaN;
            let dpi = filterData(data.dpi);
            if (mode == "Hipfire") return this.baseSpeed(filterData(data.val1)) * dpi;

            let fov = filterData(data.fov);
            let k = (data.op1 == "Off" ? this.mode2vfov[mode] : this.mode2adsvfov[mode](fov)) / toRad(fov);
            return this.baseSpeed(filterData(data.val1)) * dpi * k * filterData(data.val2) / 100.0 * filterData(data.val3) / 100.0;
        },

        calcSens: function (speed, data) {
            let mode = data.mode;
            if (!mode) return NaN;
            let dpi = filterData(data.dpi);
            if (mode == "Hipfire") {
                data.val1 = filterResult(this.invBaseSpeed(filterData(speed) / dpi));
                return;
            }
            let fov = filterData(data.fov);
            let k = (data.op1 == "Off" ? this.mode2vfov[mode] : this.mode2adsvfov[mode](fov)) / toRad(fov);
            console.log(fov, this.mode2vfov[mode], k, data.op1);
            data.val3 = filterResult(
                filterData(speed) / (this.baseSpeed(filterData(data.val1)) * data.dpi * k * filterData(data.val2) / 100.0) * 100
            );
        }
    },

    "Apex Legends": {
        modes: ["Hipfire", "1x", "2x", "3x", "4x", "6x", "8x", "10x"],

        mode2hfov43: {
            "Hipfire": 1,
            "1x": 0.7347,
            "2x": 0.3039,
            "3x": 0.2837,
            "4x": 0.1409,
            "6x": 0.0362,
            "8x": 0.0204,
            "10x": 0.0131
        },

        mode2k: {
            "1x": 1 / 1.246546,
            "2x": 1 / 2.146242,
            "3x": 1 / 3.265007,
            "4x": 1 / 4.374939,
            "6x": 4 / 6.585693,
            "8x": 1 / 8.791829,
            "10x": 1 / 10.996104,
        },
        baseSpeed: 1 / 16363.6364,

        toRadFov: function (fov) {
            return toRad(70 + (fov - 70) * 0.9625);
        },

        toActualHfov: function (hfov43, w, h) {
            let vfov43 = vFOV2hFOV(hfov43, 3, 4);
            return vFOV2hFOV(vfov43, w, h);
        },

        onModeSet: function (layout, data, is1) {
            clearLayout(layout, data);
            data.fov = 90;
            layout.fovDisable = false;
            layout.dt1Disable = false;
            if (data.mode != "Hipfire") {
                layout.dt1Label = "Sensitivity";
                layout.dt2Label = data.mode + (is1 ? "ADS Sensitivity" : "ADS Sensitivity(Outcome)");
                layout.dt2Disable = false;
                layout.dt2RO = is1 ? false : true;
            } else {
                layout.dt1Label = is1 ? "Sensitivity" : "Sensitivity(Outcome)";
                layout.dt1RO = is1 ? false : true;
            }
        },

        getTanFOV: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            let fov43 = this.toRadFov(filterData(data.fov));
            let hfov43 = fov43 * this.mode2hfov43[mode];
            return Math.tan(this.toActualHfov(hfov43, w, h) / 2);
        },

        getBaseSpeed: function (data) {
            let mode = data.mode;
            let w = filterData(data.gameRT.w);
            let h = filterData(data.gameRT.h);
            let fov43 = this.toRadFov(filterData(data.fov));
            let fov = this.toActualHfov(fov43, w, h);
            let sfov = this.toActualHfov(fov43 * this.mode2hfov43[mode], w, h);
            let theta = Math.atan(2 * Math.tan(fov / 2));
            let stheta = Math.atan(2 * Math.tan(sfov / 2));
            return stheta / theta * this.baseSpeed;
        },

        getSpeed: function (data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") return this.baseSpeed * filterData(data.dpi) * filterData(data.val1);
            return this.getBaseSpeed(data) * filterData(data.dpi) * filterData(data.val1) * filterData(data.val2);
        },

        calcSens: function (speed, data) {
            let mode = data.mode;
            if (!mode) return NaN;
            if (mode == "Hipfire") {
                data.val1 = filterResult(filterData(speed) / (this.baseSpeed * filterData(data.dpi)));
                return;
            }
            data.val2 = filterResult(
                filterData(speed) / (this.getBaseSpeed(data) * filterData(data.dpi) * filterData(data.val1))
            );
        }
    },
}

export {
    ConvModes,
    Games,
    ScreenRatio,
    GameRatio,
    GameInfo,
    GetRatio,
}